export const h = {
	login:{
			login:"เข้าสู่ระบบ",
			pleaseusername:"กรุณากรอกชื่อผู้ใช้",
			pleasepassword:"กรุณากรอกรหัสผ่าน",
			checkname:"กรุณากรอกชื่อผู้ใช้ที่ถูกต้อง",
			checkpass:"รหัสผ่านต้องไม่น้อยกว่า 3 ตัวอักษร",
		},
	navbar:{
		home:"หน้าแรก",
		mycenter:"ศูนย์ส่วนบุคคล",
		outlogin:"ล้มเลิก",
		close:"ปิด",
		editLanguage:"ภาษาการแก้ไข",
	},
	vip:{
		nickname:"ชื่อนิค",
		pleasenickname:"กรุณากรอกชื่อเล่น",
		username:"ชื่อผู้ใช้",
		pleaseusername:"กรุณากรอกชื่อผู้ใช้",
		arealogin:"พื้นที่เข้าสู่ระบบ",
		pleasearealogin:"กรุณากรอกพื้นที่เข้าสู่ระบบของคุณ",
		nationality:"ประเทศที่คุณถือสัญชาติอยู่",
		pleasenationality:"กรุณาเลือกสัญชาติ",
		depositstatus:"สถานะการฝากเงิน",
		pleasedepositstatus:"กรุณาเลือกสถานะการฝากเงิน",
		createtime:"เวลาสร้าง",
		logintime:"เข้าสู่ระบบเวลา",
		startime:"เวลาเริ่มต้น",
		endtime:"เวลาสิ้นสุด",
		no:"หมายเลขซีเรียล",
		shangji:"การแนะนำโดยตรงแก่ผู้บังคับบัญชา",
		keyongmoney:"ยอดเงินคงเหลือ",
		baozhengjing:"ระยะขอบ",
		fudongyingkui:"กำไรขาดทุนลอยตัว",
		zicantotal:"สินทรัพย์รวม",
		yaoqingma:"รหัสการเชิญ",
		zongrujing:"เงินฝากทั้งหมด",
		zongchujing:"การถอนเงินทั้งหมด",
		loginIp:"เข้าสู่ระบบไอพี",
		zuihoulogin:"เวลาเข้าสู่ระบบครั้งล่าสุด",
		shoucirujingmoney:"จำนวนเงินฝากครั้งแรก",
		shoucirujingtime:"เวลาฝากครั้งแรก",
		kaitongtime:"เวลาเปิดทำการ",
		keyong:"มีอยู่",
		daoshi:"ครูสอนพิเศษ",
		dongjie:"แช่แข็ง",
		chujingstate:"สถานะการถอนเงิน",
		xiajichujingstate:"สถานะการถอนเงินระดับล่าง",
		caozuo:"ดำเนินงาน",
		chakan:"ตรวจสอบ",
		heji:"ทั้งหมด",
		moneytotal:"ยอดรวม",
		paixu:"เรียงลำดับ",
		daochu:"ส่งออก",
		huiyuanguanli:"การจัดการสมาชิก",
		yonghu:"ผู้ใช้",
		search:"ค้นหาแบบสอบถาม",
		reset:"รีเซ็ต",
		delete:"ลบ",
		kickout:"เสือกไสไล่ส่ง",
		notlogin:"ไม่ได้เข้าสู่ระบบ",
		editLanguage:"ภาษาการแก้ไข",
		yourujing:"มีของฝาก",
		wurujing:"ไม่มีเงินฝาก",
    todayreg: "ปริมาณการลงทะเบียนในวันนี้: ",
    newvipnum: "จำนวนสมาชิกวีไอพีใหม่ที่เข้าร่วม: ",
    juese: "บทบาท",
    xiugaimima: "เปลี่ยนรหัสผ่าน",
    jiumima: "รหัสผ่านเก่า",
    shurujiumima: "กรุณາป้อนรหัสผ่านเก่า",
    xinmima: "รหัสผ่านใหม่",
    shuruxinmima: "กรุณาป้อนรหัสผ่านใหม่",
    gerenzhongxing: "ศูนย์ส่วนตัว",
    yonghuxinxi: "ข้อมูลผู้ใช้"
	},
	info:{
		home:"หน้าแรก",
		user:"รหัสผู้ใช้",
		nickname:"ชื่อนิค",
		account:"บัญชี",
		identity:"หมายเลขประจำตัวประชาชน",
		phone:"หมายเลขโทรศัพท์",
		nationality:"ประเทศที่คุณถือสัญชาติอยู่",
		Balance:"การจัดการความสมดุล",
		real:"บัญชีจริง",
		zhongmongy:"ยอดรวม",
		keyongmoney:"ยอดเงินคงเหลือ",
		jiaoyidongjie:"ธุรกรรมถูกระงับ",
		shishilirun:"กำไรแบบเรียลไทม์",
		shishikeyong:"มีจำหน่ายแบบเรียลไทม์",
		xunizhanghu:"บัญชีเสมือน",
		churujinguanli:"การจัดการการฝากและถอนเงิน",
		chakanzijinjilu:"ดูประวัติกองทุน",
		rujinjilu:"บันทึกการฝากเงิน",
		rujinjine:"จำนวนเงินฝาก",
		jiaoyibishu:"จำนวนธุรกรรม",
		chujinjilu:"บันทึกการถอนเงิน",
		chujinjine:"จำนวนเงินที่ถอน",
		jiaoyiguanli:"การจัดการธุรกรรม",
		lishijilu:"บันทึกประวัติศาสตร์",
		chakanlishi:"ดูข้อมูลการทำธุรกรรมในอดีต",
		jiaoyishoushu:"การซื้อขายจำนวนมาก",
		jiaoyiyingkui:"การซื้อขายกำไรและขาดทุน",
		dangqianchicang:"ตำแหน่งปัจจุบัน",
		chakandangqianchicang:"ดูข้อมูลตำแหน่งปัจจุบัน",
		dangqianguadan:"คำสั่งซื้อที่รอดำเนินการในปัจจุบัน",
		chakanguadanliebiao:"ดูรายการคำสั่งซื้อที่รอดำเนินการ",
		guadanbishu:"จำนวนคำสั่งซื้อที่รอดำเนินการ",
		yongjinguanli:"การจัดการค่าคอมมิชชั่น",
		duanwei:"อันดับ",
		wu:"ไม่มี",
		zhishushangji:"เหนือกว่าทันที",
		shangjidaili:"ตัวแทนที่เหนือกว่า",
		xiajituandui:"ทีมงานรอง",
		shurudailiname:"กรุณากรอกชื่อตัวแทน",
		chakan:"ตรวจสอบ",
		fanyongjie:"จำนวนเงินคืน",
		fanyongbishu:"จำนวนส่วนลด",
		chakanyongjinjilu:"ดูบันทึกส่วนลด",
		chakanyonghuinfo:"ดูรายละเอียดผู้ใช้",
		chakanwenjuan:"ดูแบบสอบถาม",
		resetpassword:"รีเซ็ตรหัสผ่าน",
		sendmsg:"ส่งข้อความ",
		update:"ปรับปรุงใหม่",
		unbound:"ไม่ผูกมัด",
		weishiming:"ไม่มีการตรวจสอบชื่อจริง",
		gendan:"การจัดการเอกสาร",
		gensui:"ติดตาม",
		chakangendan:"ดูบันทึกการสั่งซื้อ",
		dingdanhao:"หมายเลขคำสั่งซื้อ",
		shoudongpay:"เติมเงินด้วยตนเอง",
		chakanyongjingjilu:"ดูประวัติค่าคอมมิชชัน",
		xiugaiyonghuxinxi:"แก้ไขข้อมูลผู้ใช้",
		queding:"แน่นอน",
		quxiao:"ยกเลิก",
		email:"จดหมาย",
		selguoji:"กรุณาเลือกสัญชาติ",
		sendusermsg:"ส่งข้อความถึงผู้ใช้",
		title:"ชื่อ",
		shurutitle:"กรุณากรอกชื่อข้อความ",
		content:"เนื้อหา",
		shurucontent:"กรุณากรอกเนื้อหาข้อความ",
		zhenshi:"ความเป็นจริง",
		xuni:"เสมือน",
		fangxiang:"ทิศทาง",
		zhanghu:"บัญชี",
		add:"เพิ่มขึ้น",
		less:"หัก",
		type:"พิมพ์",
		guanliyuanpay:"ผู้ดูแลระบบเติมเงิน",
		pay:"เติม",
		money:"จำนวน",
		updategdmsg:"แก้ไขข้อมูลการสั่งซื้อ",
		xinhaoyuan:"แหล่งสัญญาณ",
		yes:"ใช่",
		no:"เลขที่",
		updateyongjingmsg:"แก้ไขข้อมูลค่าคอมมิชชัน",
		qingxuanzejuese:"โปรดเลือกบทบาทบัญชี",
		zuoduo:"ยาวไป",
		zuokong:"สั้น",
		gensuinicheng:"ตามด้วยชื่อเล่น",
		kaicangjia:"ราคาเปิด",
		pingcangjia:"ราคาปิด",
		shousu:"ขนาดล็อต",
		pingcangdate:"วันเปิดตำแหน่ง",
		kaicangdate:"วันปิดรับสมัคร",
		chakangensuiinfo:"ดูรายละเอียดติดตาม",
		gensuiuserno:"ติดตามหมายเลขผู้ใช้",
		gensuiyonghuname:"ติดตามชื่อเล่นของผู้ใช้",
		gensuifangshji:"ปฏิบัติตามวิธี",
		number:"ปริมาณ",
		danwei:"หน่วย",
		zhengxiang:"ซึ่งไปข้างหน้า",
		fanxaing:"ย้อนกลับ",
		beishu:"หลายรายการ",
		shousu:"ขนาดล็อต",
		gensuizhuangtai:"ติดตามสถานะ",
		genjinzhong:"การสมัครกำลังติดตาม",
		gensuiok:"ยอมทำตาม",
		gensuino:"ปฏิเสธที่จะปฏิบัติตาม",
		chexiao:"ยกเลิก",
		gensuidate:"ทำตามเวลา",
		chakanlishijiaoyi:"ดูข้อมูลการทำธุรกรรมในอดีต",
		chakanguadanlist:"ดูรายการคำสั่งซื้อที่รอดำเนินการ",
		heyue:"สัญญา",
		daili:"การแสดง",
		huiyuanname:"ชื่อสมาชิก",
		xianjia:"ขีด จำกัด ราคา",
		zhisun:"หยุดการสูญเสีย",
		guadanjia:"ราคาคำสั่งซื้อที่รอดำเนินการ",
		zhiyingzhisun:"ขายทำกำไรและหยุดการขาดทุน",
		zhiyingjia:"ราคาขายทำกำไร",
		zhiyinghuichejia:"ขายทำกำไรราคาย้อนกลับ",
		zhisunjia:"หยุดราคาขาดทุน",
		zhisunhuichejia:"หยุดราคาขาดทุนย้อนกลับ",
		weiset:"ไม่ได้ตั้งค่า",
		zt:"สถานะ",
		chakanchicangmsg:"ดูข้อมูลตำแหน่งปัจจุบัน",
		shouyiId:"รหัสผู้รับผลประโยชน์",
		xiajiid:"ID ผู้ใช้รอง",
		xiajiuser:"ชื่อผู้ใช้รอง",
		fanyongmonney:"จำนวนเงินคืน",
		tuihuibaozhengjing:"ฝากคืน",
		shouxufei:"ค่าธรรมเนียมการจัดการ",
		shouyi:"รายได้",
		lixi:"ความสนใจ",
		zengmoney:"โบนัส",
		zhuijiabaozhengjing:"การเรียกหลักประกัน",
		fanyong:"ส่วนลด",
		rujing:"เงินฝาก",
		chujing:"ถอนเงิน",
		chujingshibai:"คืนเงินหากการตรวจสอบการถอนล้มเหลว",
		guanliyuanless:"แอดมินหัก",
		pingzhong:"ความหลากหลาย",
		shengqingzhong:"กำลังสมัคร",
		wancheng:"เสร็จ",
		chongzhimima:"รีเซ็ตรหัสผ่านสำเร็จ",
		copy:"สำเนา",
		zhanghaomima:"รหัสผ่านบัญชี",
		fenye:"บทความ/หน้า",
    tixianmima:"ถอนรหัสผ่าน",
		gong:"ทั่วไป",
		tiao:"เปลื้องผ้า",
		ye:"หน้าหนังสือ",
		goto:"ไปที่",
		outtitle:"คุณออกจากระบบแล้ว คุณสามารถยกเลิกและอยู่ในหน้านี้หรือเข้าสู่ระบบอีกครั้ง",
		outok:"ตกลงเพื่อออกจากระบบ",
		chongxingdenglu:"ลงทะเบียนใหม่",
		cancel:"ยกเลิก",
		pingtai:"แพลตฟอร์ม",
		nodata:"ไม่มีข้อมูล",
    shangjiID: "ID เย�ยหรด",
    shangjiaccount: "บัญชี เย�ยหรด",
    shangjiname: "ชื่อเล่น เย�ยหรด",
    shangjinickname: "ชื่อ เย�ยหรด",
    zhongyingkui: "กำไรขาดทุนรวม",
    fuying: "กำไรลอย",
    yue: "ยอดเหลือ",
    sheng: "เรียงอันดับເພີ່ມ",
    jiang: "เรียงอັນดับลด"
	},
	history:{
			guadan:"กำไรและขาดทุน",
			shijia:"รอดำเนินการสั่งซื้อ",
			gendan:"ราคาตลาด",
			dangqianjia:"ทำตามคำสั่ง",
			geyelixi:"ราคาปัจจุบัน",
			weituodate:"ดอกเบี้ยข้ามคืน",
			pingcangfangshi:"เวลาคอมมิชชั่น",
			dingdanyongjing:"วิธีการปิด",
			shoudongpingcang:"ค่าคอมมิชชันการสั่งซื้อ",
			qiangzhipingcang:"การปิดด้วยตนเอง",
			gendanpingcang:"การบังคับชำระบัญชี",
			baocang:"การชำระบัญชี",
			yuguqiangpingjia:"ปฏิบัติตามคำสั่งเพื่อปิดตำแหน่ง",
			kaicangdiqu:"ราคาประมาณความเท่าเทียมกันแบบบังคับ",
			ispingcang:"พื้นที่เปิด",
			tips:"คุณแน่ใจเกี่ยวกับการบังคับชำระบัญชีหรือไม่?",
			pincangsucc:"คำใบ้",
			queding:"ปิดตำแหน่งเรียบร้อยแล้ว",
			cancel:"แน่นอน"
		},

	Langswitch: {
	  "en":"ภาษาอังกฤษ",
	  "id":"ชาวอินโดนีเซีย",
	  "th":"ภาษาไทย",
	  "vi":"ภาษาเวียดนาม",
	  "zh":"ชาวจีน",
	  "fa":"ภาษาฝรั่งเศส",
	  "han":"เกาหลี",
	  "tu":"ตุรกี",
	  "pu":"โปรตุเกส",
	  "xi":"สเปน",
	  "jp":"ญี่ปุ่น",
	  "ar":"ภาษาอาหรับ",
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/th.js